import moment from 'moment';
import type { JsonObject } from '@/app-package';
import type { AppointmentDoc } from '@bb/domain/dist/schemas';
import { formatISODateStr } from 'utils';

function sortAppointments(
  appointments: JsonObject<AppointmentDoc>[],
  sortDirection: 'asc' | 'desc' = 'asc',
) {
  const sortedAppointments = appointments.sort((a, b) => {
    if (sortDirection === 'asc') {
      return moment(a.time).unix() - moment(b.time).unix();
    }
    return moment(b.time).unix() - moment(a.time).unix();
  });
  const sortedDates: string[] = [];
  const groupedAppointmentsByDate: {
    [key: string]: JsonObject<AppointmentDoc>[];
  } = {};
  sortedAppointments.forEach(appointment => {
    const dateString = formatISODateStr(
      appointment.time,
      appointment.listing.timezone,
    );
    if (!sortedDates.includes(dateString)) {
      sortedDates.push(dateString);
      groupedAppointmentsByDate[dateString] = [appointment];
    } else {
      groupedAppointmentsByDate[dateString].push(appointment);
    }
  });

  return { sortedDates, groupedAppointmentsByDate };
}

export default sortAppointments;
